/**
 * External Imports
 */
import { FC } from 'react';
import { useDispatch } from 'react-redux';

/**
 * Neutron UI Imports
 */
/**
 * Internal Imports
 */
import { useLocation } from 'react-router-dom';
import {
  clearAdminUserFilter,
  clearCensusReportFilter,
  clearComplianceReportFilter,
  clearEmployeeShiftStatusFilter,
  clearEmployeeSummaryReportFilter,
  clearFeedbackFilter,
  clearFrequencyReportFilter,
  clearIssueFilter,
  clearRoundsReportFilter,
  clearStoplightFilter,
  clearPatientSummaryReportFilter
} from '../../../redux/actions';

/**
 * Style Imports
 */
import { StyledClearFilterBtn } from './ClearFilterBtn.styles';

const ClearFilterBtn: FC<{}> = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const clearFilter = () => {
    if (pathname.includes('stoplight')) {
      dispatch(clearStoplightFilter());
    } else if (pathname.includes('issues')) {
      dispatch(clearIssueFilter());
    } else if (pathname.includes('feedback')) {
      dispatch(clearFeedbackFilter());
    }
    dispatch(clearAdminUserFilter());
    dispatch(clearRoundsReportFilter());
    dispatch(clearComplianceReportFilter());
    dispatch(clearPatientSummaryReportFilter());
    dispatch(clearEmployeeSummaryReportFilter());
    dispatch(clearCensusReportFilter());
    dispatch(clearEmployeeShiftStatusFilter());
    dispatch(clearFrequencyReportFilter());
  };

  return (
    <StyledClearFilterBtn
      id="Clear-Filter-Button"
      data-testid="clear-filter-btn"
      color="orange"
      kind="tertiary"
      size="small"
      style={{ fontSize: '1rem', marginRight: '10px' }}
      onClick={clearFilter}
      icon="close"
    >
      Clear Filters
    </StyledClearFilterBtn>
  );
};

export default ClearFilterBtn;
